export default __webpack_public_path__ + "static/media/blue-tick.94cb6563.svg";